import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
/**
 * RASXOD AKTINING HOLATLARI.
 *
 * `DRAFT` ataylab YO'Q: akt bitta oynada to'ldiriladi va o'sha yerdan
 * yuboriladi. Yarim to'ldirilgan aktni saqlaydigan joy bo'lsa, u navbatga
 * tushmasdan yillab yotib qolardi va bo'linma qoldig'i haqiqatdan
 * jimgina uzoqlashib borardi.
 *
 * `APPROVED` va `CANCELLED` — YAKUNIY. `REJECTED` dan faqat aktning EGASI
 * qaytara oladi va faqat AYNI aktni: yangisi ochilsa, oldingi rad etish
 * sababi tarixdan uzilib qolardi.
 */
export const WRITE_OFF_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'CANCELLED'];
export const writeOffStatusSchema = z.enum(WRITE_OFF_STATUSES);
const idSchema = z.string().regex(/^\d+$/);
const fileIdSchema = z.string().uuid();
/**
 * Rasxod JOYI — brauzerdan olinadi.
 *
 * `null` bo'lishi mumkin va bu ataylab: telefonda geolokatsiya o'chiq
 * bo'lsa, xodim umuman rasxod qila olmay qolardi. Buxgalter ro'yxatda
 * «lokatsiyasiz» belgisini ko'radi va kerak bo'lsa o'zi so'raydi.
 *
 * `accuracy` metrda — sun'iy yo'ldosh signali zaif joyda koordinata
 * yuz metrga adashishi mumkin va buni buxgalter bilishi kerak.
 */
export const writeOffLocationSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    accuracy: z.number().nonnegative().nullable(),
});
/**
 * AKT YUBORISH so'rovi.
 *
 * Bitta akt — bitta SATR (partiya + miqdor). Erkin savat qilinmadi:
 * qog'ozdagi aktga yaqinroq bo'lsa-da, u har satrni alohida tasdiqlash
 * yoki rad etish imkonini yo'qotardi — buxgalter esa aynan shuni qiladi.
 */
export const createWriteOffSchema = z.object({
    /** Qaysi LOTdan — bitta partiya bir nechta omborda turishi mumkin. */
    lotId: idSchema,
    qty: z.number().positive().max(1_000_000_000),
    /** Akt qog'ozi — MAJBURIY: usiz rasxod buxgalteriya uchun hujjatsiz qoladi. */
    actFileId: fileIdSchema,
    /*
     * Foto-hisobot. Yuqori chegara bor — cheksiz ro'yxat bitta so'rovda
     * o'nlab faylni band qilib qo'yardi.
     *
     * Pastki chegara («kamida bitta») OLIB TASHLANDI va buni sxema hal
     * qila olmaydi: rasm majburiyligi LOTning holatiga bog'liq. Ilovada
     * skanerlab olingan miqdor uchun dalil allaqachon bor — kim, qachon
     * va nima uchun olgani yozilgan — undan ortig'i uchun esa yo'q.
     * Shartni server tekshiradi (`writeoff/domain/availability.ts`),
     * chunki faqat u javondagi haqiqiy qoldiqni biladi.
     */
    photoFileIds: z.array(fileIdSchema).max(10),
    reason: z.string().trim().min(1).max(500),
    location: writeOffLocationSchema.nullable(),
});
/** Rad etish — sabab MAJBURIY: usiz xodim nima tuzatishni bilmaydi. */
export const rejectWriteOffSchema = z.object({
    reason: z.string().trim().min(1).max(500),
});
export const writeOffQuerySchema = paginationQuerySchema.extend({
    status: writeOffStatusSchema.optional(),
});
export const WRITE_OFF_DECISIONS = ['APPROVE', 'REJECT'];
//# sourceMappingURL=write-off.schema.js.map